import React from 'react'
import PropTypes from 'prop-types'
import CampaignEditorConfig from 'common/constants/CampaignEditorConfig'

import './style.css.scss'

const Overlay = ({ tint, themeColorHex }) => {
  const tintConfig = CampaignEditorConfig.background_tint[tint]

  const style = {
    backgroundColor: tintConfig.gradient_override || themeColorHex,
    opacity: tintConfig.opacity
  }

  return <div className='banner-overlay' style={style} />
}

Overlay.propTypes = {
  tint: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default Overlay